import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Guard to decide whether the sign-in route is activated or not.
 */
export const LoginGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);

  // Check if the user is already authenticated
  if (authService.isAuthenticated()) {
    try {
      // If authenticated, logout and return false (prevent navigation)
      return authService.logout();
    } catch (e) {
      return of(true);
    }
  }
  return true;
};
